export default class StartServiceRequest {
    public deviceId: string = "";
}